import Loader from './loader.vue';
import { createVNode, render } from 'vue';

export default {
  install(app) {
    let loaderVNode = null;
    let loaderData = {};
    window.loader = function () {};
    const dimOn = () => {
      const isBodyScroll = document.body.scrollHeight > document.body.clientHeight;
      if (isBodyScroll) {
        document.body.classList.add('loader-on', 'loader-on-scroll');
      } else {
        document.body.classList.add('loader-on');
      }
    };
    const dimOff = () => {
      document.body.classList.remove('loader-on', 'loader-on-scroll');
    };
    const methods = {
      open: (rootId) => {
        const el = document.createElement('div');
        dimOn();
        if (rootId) {
          loaderData.rootId = rootId;
          loaderData.isShowLoader = true;
          loaderData.el = this.$el;
        } else {
          loaderData.rootId = 'app';
          loaderData.isShowLoader = true;
          loaderData.el = this.$el;
        }
        loaderVNode = createVNode({
          data: loaderData,
          extends: Loader,
          mounted() {}
        });
        loaderVNode.appContext = app._context;
        render(loaderVNode, el);
        document.getElementById(loaderData.rootId).appendChild(loaderVNode.el);
      },
      close: () => {
        dimOff();
        if (loaderVNode) {
          loaderVNode.type.data.isShowLoader = false;
          document.getElementById(loaderVNode.type.data.rootId).removeChild(loaderVNode.el);
        }
      }
    };
    app.config.globalProperties.$loader = methods;
  }
};
